export const BORDER_STYLES = ["none", "thin", "thick", "double"] as const;
export type BorderStyle = (typeof BORDER_STYLES)[number];

export const isBorderStyle = (value: unknown): value is BorderStyle =>
  BORDER_STYLES.includes(value as BorderStyle);
